import { useState } from 'react';

const HeaderPromo = () => {
  const promoCode = 'GEOBLACK30';
  const [copyCodeText, setCopyCodeText] = useState('Copy code');

  const copyPromo = () => {
    navigator.clipboard.writeText(promoCode).catch(() => {});
    setCopyCodeText('Copied!');
    setTimeout(() => {
      setCopyCodeText('Copy code');
    }, 1000);
  };

  return (
    <div className="headerDiscount promo">
      <span>
        <strong>November 28 - December 5 / 2025</strong>
      </span>
      <span>
        <strong>30% Discount on YEARLY PLANS!</strong> &#8594; Use code <code>{promoCode}</code> on payment page!
      </span>
      <div className="promoActions">
        <button type="button" className="promoCopy" onClick={copyPromo}>
          {copyCodeText}
        </button>
      </div>
    </div>
  );
};

export default HeaderPromo;
